import { TaskCreationPlaceholders, TaskCompletionPlaceholders, TaskDeletionPlaceholders } from './TaskPlaceholders';
import { EventCreatePlaceholders, EventReSchedulePlaceholders, EventDeletePlaceholders } from './EventPlaceholders';

export * from './TaskPlaceholders';
export * from './EventPlaceholders';

/** Placeholders for seeded task/calendar automatic email templates only. */
export const EMAIL_TEMPLATE_PLACEHOLDERS: Record<string, Record<string, string>> = {
    "Task creation": TaskCreationPlaceholders,
    "Task completion": TaskCompletionPlaceholders,
    "Task deletion": TaskDeletionPlaceholders,
    "Event creation": EventCreatePlaceholders,
    "Event Reschedule": EventReSchedulePlaceholders,
    "Event Delete": EventDeletePlaceholders,
};
